import { Navigate, Outlet, Routes, Route } from 'react-router-dom';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { Layout } from './components/layout/Layout';
import { Dashboard } from './pages/Dashboard';
import { Services } from './pages/Services';
import { Audit } from './pages/Audit';
import { Games } from './pages/Games';
import { Firewall } from './pages/Firewall';
import { Backups } from './pages/Backups';
import { Webserver } from './pages/Webserver';
import { MySQL } from './pages/MySQL';
import { ErrorLog } from './pages/ErrorLog';
import { About } from './pages/About';
import { Users } from './pages/Users';
import { Security } from './pages/Security';
import { FlowDoc } from './pages/FlowDoc';
import { Wishlist } from './pages/Wishlist';
import { Development } from './pages/Development';
import { DiscordWebhooks } from './pages/DiscordWebhooks';
import { CronJobs } from './pages/CronJobs';
import { Sessions } from './pages/Sessions';
import { LoginActivity } from './pages/LoginActivity';
import { Claude } from './pages/Claude';
import { SecurityAudit } from './pages/SecurityAudit';
import { Settings } from './pages/Settings';
import { ResourceAlert } from './pages/ResourceAlert';
import { Debugging } from './pages/Debugging';
import { Login } from './pages/Login';
import { Home } from './pages/Home';
import { useAuth } from './context/AuthContext';

function ProtectedRoute() {
  const { auth } = useAuth();
  if (auth.status === 'loading') {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }
  if (auth.status !== 'authenticated') return <Navigate to="/login" replace />;
  return <Outlet />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Home />} />
      <Route element={<ProtectedRoute />}>
        <Route path="/" element={<Layout />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="services" element={<Services />} />
          <Route path="audit" element={<Audit />} />
          <Route path="games" element={<Games />} />
          <Route path="firewall" element={<Firewall />} />
          <Route path="backups" element={<Backups />} />
          <Route path="webserver" element={<Webserver />} />
          <Route path="subdomains" element={<Navigate to="/webserver" replace />} />
          <Route path="mysql" element={<MySQL />} />
          <Route path="errors" element={<ErrorLog />} />
          <Route path="about" element={<About />} />
          <Route path="users" element={<Users />} />
          <Route path="security" element={<Security />} />
          <Route path="security-audit" element={<SecurityAudit />} />
          <Route path="wishlist" element={<Wishlist />} />
          <Route path="help/flow" element={<FlowDoc />} />
          <Route path="development" element={<Development />} />
          <Route path="discord" element={<DiscordWebhooks />} />
          <Route path="cron" element={<CronJobs />} />
          <Route path="sessions" element={<Sessions />} />
          <Route path="login-activity" element={<LoginActivity />} />
          <Route path="claude" element={<Claude />} />
          <Route path="settings" element={<Settings />} />
          <Route path="resource-alert" element={<ResourceAlert />} />
          <Route path="debugging" element={<Debugging />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}
